// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"tW","backgroundimage":"uW","header":"vW","headerwrap":"wW","title":"xW","promomessage":"yW","upsellItem":"zW","upsellImg":"AW","helperText":"BW","upsellHeadline":"CW","price":"EW","upsellGross":"FW","upsellNet":"GW","upsellButton":"HW","nutritionfacts":"IW","nutritionimg":"JW","containerwhy":"KW","nutritionwrappwer":"LW","headlinewhy":"MW","boxwhy":"NW","textwhy":"OW","backbutton":"PW","drawercontainer":"QW","logoheader":"RW","textwrap":"SW","timer":"TW"};
    if(module.hot) {
      // 1721922367920
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  